var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaylists = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 44,
    viewBox: "0 0 60 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 3.3335H3.33336M3.33336 16.6668H33.3334M23.3334 30.0002H3.33336",
    stroke: "white",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1462 16.4206C47.0108 16.3699 46.8652 16.3528 46.7218 16.3706C46.5784 16.3885 46.4414 16.4408 46.3226 16.5231C46.2039 16.6054 46.1068 16.7153 46.0397 16.8433C45.9726 16.9713 45.9375 17.1137 45.9375 17.2582V31.7279C45.1106 31.0659 44.0871 30.6978 43.028 30.6815C41.9689 30.6652 40.9345 31.0016 40.0876 31.6379C39.2408 32.2741 38.6297 33.174 38.3505 34.1957C38.0714 35.2175 38.14 36.3031 38.5457 37.2815C38.9514 38.26 39.671 39.0757 40.5912 39.6002C41.5115 40.1247 42.5801 40.3281 43.6286 40.1785C44.6772 40.0289 45.6463 39.5347 46.3831 38.7738C47.12 38.0129 47.5828 37.0285 47.6986 35.9756C47.7175 35.9028 47.7271 35.8278 47.7272 35.7525V24.5151L56.064 27.6413C56.1994 27.692 56.345 27.7091 56.4884 27.6912C56.6318 27.6734 56.7687 27.6211 56.8875 27.5387C57.0063 27.4564 57.1034 27.3466 57.1705 27.2185C57.2376 27.0905 57.2726 26.9482 57.2727 26.8037V22.9055C57.2729 22.1159 57.0321 21.3451 56.5824 20.696C56.1327 20.047 55.4956 19.5507 54.7563 19.2735L47.1462 16.4206Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaylists);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/playlists.47320b213b9e0bb7be23c4434d536828.svg";